
import { uploadTrackers, UPLOAD_EVENT_ACTIONS } from './upload';

export type ValidEventActions = UPLOAD_EVENT_ACTIONS;

export const VALID_EVENT_ACTIONS = {
  ...UPLOAD_EVENT_ACTIONS,
};

const eventTrackers: { [key in ValidEventActions]: () => void } = {
  ...uploadTrackers,
};

export default eventTrackers;
